<template>
  <v-data-table
    :search="searchInput"
    :headers="sectionHeaders"
    :items="sections"
    :loading="sectionsLoading"
    :footer-props="{
      itemsPerPageOptions: sectionsPerPage,
    }"
  >
    <template v-slot:[`item.icon`]="{ item }">
      <v-chip :class="`secondary-${item.color}-bg`" label text-color="white">
        <v-icon :color="item.color">mdi-{{ item.icon }}</v-icon>
      </v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn-toggle rounded>
        <v-btn class="remove-toggled-state" small color="success" @click="openDialog('view', item.id)">
          <v-icon small color="white"> mdi-eye </v-icon>
        </v-btn>
        <v-btn class="remove-toggled-state" small color="info" @click="openDialog('upload', item.id)">
          <v-icon small color="white"> mdi-account-multiple-plus </v-icon>
        </v-btn>
        <v-btn class="remove-toggled-state" small color="primary" @click="openDialog('edit', item.id)">
          <v-icon small color="white"> mdi-pencil </v-icon>
        </v-btn>
        <v-btn class="remove-toggled-state" small color="error" @click="openDialog('delete', item.id)">
          <v-icon small color="white">mdi-delete</v-icon>
        </v-btn>
      </v-btn-toggle>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'SectionList',
  props: {
    searchInput: {
      type: String,
      default: '',
    },
    filterSectionsByGrade: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sectionsPerPage: [10, 15, 25, 50, 100],
    };
  },
  computed: {
    sections: function () {
      return this.$store.state.sectionsModule.sections;
    },
    sectionsLoading: function () {
      return this.$store.state.sectionsModule.sectionsLoading;
    },
    sectionHeaders: function () {
      return [
        {
          text: 'Section Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Grade Level',
          align: 'center',
          sortable: true,
          value: 'gradeLevel',
          filter: (value) => {
            if (!this.filterSectionsByGrade) {
              return true;
            }
            return this.filterSectionsByGrade == value;
          },
        },
        {
          text: 'Adviser',
          align: 'start',
          sortable: true,
          value: 'teacherName',
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
        },
      ];
    },
  },
  methods: {
    openDialog(action, sectionId) {
      this.$emit('openDialog', { action: action, sectionId: sectionId });
    },
  },
  async mounted() {
    await this.$store.dispatch('sectionsModule/getSections');
  },
};
</script>
<style scoped>
.remove-toggled-state {
  color: white !important;
}
</style>
